const compareTwoDates = (foo: Date, bar: Date) => Math.floor((bar.getTime() - foo.getTime()) / (1000 * 60 * 60 * 24));

export { compareTwoDates };
